import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(({ spacing, palette }) => ({
  root: {
    '& .MuiPaper-root': {
      width: `${spacing(720)} !important`,
      maxWidth: 'none !important',
      overflowX: 'hidden',
      boxSizing: 'border-box',
      borderRadius: spacing(12),
    },
    '& .MuiDialogTitle-root': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      padding: spacing(20, 0, 0, 0),
    },
    '& .MuiDialogTitle-root .MuiTypography-root': {
      textAlign: 'left',
      width: '100%',
      fontWeight: 600,
      margin: spacing(0, 20),
    },
    '& .MuiDialogContent-root': {
      overflowX: 'hidden',
      overflowY: 'hidden',
      padding: `${spacing(0, 20)} !important`,
      gap: spacing(16),
    },
  },
  headerLine: {
    width: '100%',
    border: '1px solid #E3E3E3',
    marginTop: spacing(8),
    marginBottom: spacing(24),
  },
  headerInfo: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(8),
    alignItems: 'center',
  },
  question: {
    fontWeight: 700,
    fontSize: spacing(24),
    lineHeight: spacing(32),
    color: palette.gray[80],
    textAlign: 'center',
  },
  subQuestion: {
    fontSize: spacing(16),
    lineHeight: spacing(24),
    color: palette.gray[64],
    textAlign: 'center',
  },
  additionalInfo: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: spacing(8),
    width: '100%',
    marginBottom: spacing(24),
  },
  additionalLink: {
    fontSize: spacing(16),
    lineHeight: spacing(24),
    textAlign: 'center',
  },
  additionalText: {
    fontSize: spacing(16),
    lineHeight: spacing(24),
    color: palette.gray[64],
    textAlign: 'center',
  },
  optionGroup: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: spacing(20),
    width: '100%',
    marginTop: spacing(8),
    marginBottom: spacing(4),
  },
  optionWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    cursor: 'pointer',
    borderRadius: spacing(12),
    border: `2px solid ${palette.gray[16]}`,
    padding: spacing(16),
    transition: 'border-color 0.2s, background-color 0.2s',
    '&:hover': {
      borderColor: palette.primary.main,
    },
    '&:active': {
      transform: 'scale(0.98)',
      boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
    },
  },
  optionSelected: {
    border: `2px solid ${palette.primary.main}`,
  },
  optionCard: {
    width: '100%',
    minHeight: spacing(140),
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(8),
    justifyContent: 'center',
    alignItems: 'center',
  },
  optionIcon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: spacing(64),
    height: spacing(64),
    borderRadius: '50%',
    backgroundColor: palette.primary.lightest,
    color: palette.primary.main,
  },
  optionTitle: {
    fontWeight: 700,
    fontSize: spacing(18),
    lineHeight: spacing(24),
    color: palette.gray[80],
  },
  confirmButton: {
    minWidth: spacing(140),
  },
  footerActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    width: '100%',
  },
  footerRight: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: spacing(20),
    width: 'auto',
  },
}))
